export default[
    //选择银行卡
    {
        path:'/valorpec/card',
        name:'cardlist',
        meta:{
            title:'Banco'
        },
        component:()=>import('@/valorpecapp/views/card/list/index')
    },
    //添加银行卡
    {
        path:'/valorpec/card/add',
        name:'bindcard',
        meta:{
            title:'Añadir una tarjeta bancaria'
        },
        component:()=>import('@/valorpecapp/views/card/add/index')
    },
    //订单页面
    {
        path:'/valorpec/order',
        name:'order',
        meta:{
            title:'Detalles del pedido'
        },
        component:()=>import('@/valorpecapp/views/order/index/index')
    },
    //展期订单
    {
        path:'/valorpec/order/delayed/:orderId',
        name:'orderDelayed',
        meta:{
            title:'Extensión de pago'
        },
        component:()=>import('@/valorpecapp/views/order/delayed/index')
    },
    //历史订单列表
    {
        path:'/valorpec/order/history',
        name:'orderhistory',
        meta:{
            title:'Pedidos históricos'
        },
        component:()=>import('@/valorpecapp/views/order/history/index')
    },
    //历史订单详情
    {
        path:'/valorpec/order/history/details/:orderId',
        name:'orderdetails',
        meta:{
            title:'Detalles del pedido'
        },
        component:()=>import('@/valorpecapp/views/order/details/index')
    },
    //完成订单
    {
        path:'/valorpec/order/detail/:orderId/:loanTenureType/:curInstallment',
        name:'detail',
        meta:{
            title:'Detalles del pedido'
        },
        component:()=>import('@/valorpecapp/views/order/successes/index')
    },
    //客服
    {
        path:'/valorpec/customer/index',
        name:'customer',
        meta:{
            title:'Comentarios sobre el servicio'
        },
        component:()=>import('@/valorpecapp/views/customer/index')
    },
    //FAQ常见问题
    {
        path:'/valorpec/faq',
        name:'faqIndex',
        meta:{
            title:'FAQ'
        },
        component:()=>import('@/valorpecapp/views/faq/index/index.vue')
    },
    //借款协议
    {
        path:'/valorpec/agreement',
        name:'agreementIndex',
        meta:{
            title:'Acuerdo de Préstamo Personal'
        },
        component:()=>import('@/valorpecapp/views/agreement/index/index.vue')
    },
]



// WEBPACK FOOTER //
// ./src/valorpecapp/router/router.js